import useUser from './useUser';
import { useGetUserProjectsQuery } from '../../redux/rtk';
import { jobHasPointCloud } from '../../utilities/job';

const useHasProjectWithPointcloud = (includeDemo = false) => {
  const { isAdmin, isSuccess } = useUser();
  const result = useGetUserProjectsQuery(
    { isAdmin, includeDemo },
    {
      skip: !isSuccess,
      selectFromResult: (res) => {
        const obj = res.data?.projects;
        if (!obj) return { ...res, data: false };

        const hasPointCloud = Object.values(obj).some((project) =>
          jobHasPointCloud(project)
        );
        return { ...res, data: hasPointCloud };
      },
    }
  );

  return {
    hasPointCloud: result.data,
    isLoading: result.isLoading || !isSuccess,
    status: result.status,
  };
};

export default useHasProjectWithPointcloud;
